import range from 'lodash/range';
import { Info } from 'luxon';
import { computed } from 'vue';

import CountryCallingCodes from '@/config/CountryCallingCodes';
import Gender from '@/enums/Gender';
import PetSpecies from '@/enums/PetSpecies';
import { i18n } from '@/i18n';

export default function useFormHelpers() {
  const getCountryCallingCodeOptions = computed(() => [
    {
      value: '',
      text: `— ${i18n.t('common.choose')} —`,
    },
    ...CountryCallingCodes.map((country) => ({
      value: country.code,
      text: `${country.name} (${country.prefix})`,
    })),
  ]);

  const getYearOptions = (start, end) => range(
    end || new Date().getFullYear(),
    start || 1920,
  );

  const getMonthOptions = (locale = 'en-US') => {
    const options = [];

    const monthNames = Info.months('long', { locale });
    const monthNumber = Info.months('numeric', { locale });

    for (let i = 0; i < 12; i += 1) {
      options.push({
        value: monthNumber[i],
        text: monthNames[i],
      });
    }

    return options;
  };

  const getSpeciesRadioOptions = computed(() => PetSpecies.values().map((value) => ({
    value,
    text: i18n.t(`pets.species.${value}`),
  })));

  const yesNoOptions = [
    { value: true, text: i18n.t('common.yes'), icon: ['fal', 'check'] },
    { value: false, text: i18n.t('common.no'), icon: ['fal', 'empty-set'] },
  ];

  const petGenderOptions = [
    {
      value: Gender.Female,
      text: i18n.t('common.genders.FEMALE'),
      icon: ['fal', 'venus'],
    },
    {
      value: Gender.Male,
      text: i18n.t('common.genders.MALE'),
      icon: ['fal', 'mars'],
    },
  ];

  return {
    getCountryCallingCodeOptions,
    getYearOptions,
    getMonthOptions,
    getSpeciesRadioOptions,
    yesNoOptions,
    petGenderOptions,
  };
}
